export const RiskledgerTrackingIdHeader = 'riskledger-tracking-id';

// CSRF custom-required-header (OWASP) — backend rejects cookie-authed mutations
// without a non-empty value. The value isn't validated, only its presence.
export const CsrfTokenHeader = 'X-CSRF-Token';
export const CsrfTokenValue = '1';
